// Forks should change this.
// This can be accessed externally on `vm.runtime.platform`

module.exports = {
    name: 'PotentiaMod',
    url: 'https://potentiamod.github.io/'
};
